import { render, staticRenderFns } from "./AdminCategory.vue?vue&type=template&id=f36c6348&scoped=true&"
import script from "./AdminCategory.vue?vue&type=script&lang=ts&"
export * from "./AdminCategory.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCategory.vue?vue&type=style&index=0&id=f36c6348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36c6348",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VDialog,VTextField,VTreeview})
